import { Download, Share2 } from 'lucide-react';
import { useState } from 'react';

import { usePwaInstall } from '@/features/pwa/hooks/usePwaInstall';

type PwaInstallButtonProps = {
  variant?: 'primary' | 'secondary' | 'menu';
  showHelper?: boolean;
};

function getButtonClass(variant: 'primary' | 'secondary' | 'menu') {
  if (variant === 'primary') {
    return 'inline-flex min-h-11 items-center justify-center gap-2 rounded-xl bg-brand-600 px-3 py-2 text-sm font-semibold text-white hover:bg-brand-700';
  }
  if (variant === 'menu') {
    return 'inline-flex min-h-11 w-full items-center gap-3 rounded-xl px-3 py-3 text-left text-sm font-medium text-slate-700 hover:bg-slate-100 dark:text-slate-200 dark:hover:bg-slate-800';
  }
  return 'inline-flex min-h-11 items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-100 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800';
}

export function PwaInstallButton({ variant = 'secondary', showHelper = true }: PwaInstallButtonProps) {
  const { platform, isInstallable, isInstalled, install } = usePwaInstall();
  const [showIosHelp, setShowIosHelp] = useState(false);

  if (isInstalled) {
    return null;
  }

  if (platform === 'ios' && !isInstallable) {
    return (
      <div className="space-y-2">
        <button
          type="button"
          className={getButtonClass(variant)}
          onClick={() => setShowIosHelp(value => !value)}
        >
          <Share2 className="h-4 w-4" />
          Install App
        </button>
        {showHelper && showIosHelp ? (
          <p className="rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-600 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300">
            On iPhone/iPad: tap <strong>Share</strong>, then <strong>Add to Home Screen</strong>.
          </p>
        ) : null}
      </div>
    );
  }

  if (!isInstallable) {
    return null;
  }

  return (
    <button
      type="button"
      className={getButtonClass(variant)}
      onClick={() => {
        void install();
      }}
    >
      <Download className="h-4 w-4" />
      Install App
    </button>
  );
}
